import { Injectable } from '@angular/core';

/** Holds the active short URL document id between guard activation and the public form page. */
@Injectable({
  providedIn: 'root',
})
export class PublicFormShortLinkService {
  private _shortUrlDocId: string | null = null;

  setShortUrlDocId(id: string): void {
    this._shortUrlDocId = id;
  }

  get shortUrlDocId(): string | null {
    return this._shortUrlDocId;
  }

  clear(): void {
    this._shortUrlDocId = null;
  }
}
